import SubtleBadge from '@/components/common/SubtleBadge';
import { Nav } from 'react-bootstrap';


const KeywordSettingsTabs = () => {
  return (
    <Nav variant="tabs">
      <Nav.Item>
        <Nav.Link
          eventKey="updateSettings"
          className="ps-0 navLinkForceColor cursor-pointer outline-none"
        >
          به‌روزرسانی
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          eventKey="notificationSettings"
          className="px-2 navLinkForceColor px-md-3 cursor-pointer outline-none"
        >
          اطلاع‌رسانی{' '}
          <SubtleBadge bg="success" className="ms-1">
            جدید
          </SubtleBadge>
        </Nav.Link>
      </Nav.Item>
    </Nav>
  );
};

export default KeywordSettingsTabs;
